// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + (chunkId === 792 ? "main" : chunkId) + "." + {"177":"38a184b9534619f0d94d","792":"2c224d8586faf0eac5c1"}[chunkId] + ".css";
};